import axiosInstance, { CustomAxiosRequestConfig } from "../services/axios";
import { IMedia } from "../types";
import { IBlog } from "../types/blog";
import { Endpoints } from "./endpoint";
import { QueryObject } from "./global";
export type CreateBlogData={
   title:string,
      content:string,
      author:string,
      status:string,
      coverImage:string|IMedia 
      tags:string[],
}
export const CreateBlogApi=async(payload:Partial<CreateBlogData>)=>{
    const res=await axiosInstance.post(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.BLOG.CREATE}`,
      payload,
      {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}


export const updateBlogApi=async(payload:Partial<IBlog>)=>{
  const {_id,...data}=payload;
  const res = await axiosInstance.put(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.BLOG.CREATE}/${_id}`,
      data,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const removeBlogApi=async(id:string)=>{
  if(!id) return null;
  const res = await axiosInstance.delete(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.BLOG.CREATE}/${id}`,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const getBlogsApi=async(payload:Partial<QueryObject<{status:string,title:string}>>)=>{
    

    let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.BLOG.CREATE}`;
    const queryParams = [];
  
    if (payload.page !== undefined) {
      queryParams.push(`page=${payload.page}`);
    }

    if(payload.title!==undefined){
        queryParams.push(`title=${payload.title}`);
    }
     
    queryParams.push(`populate=coverImage`);

    if(payload.status!==undefined){
        queryParams.push(`status=${payload.status}`);
    }
 
    if (payload.limit !== undefined) {
      queryParams.push(`limit=${payload.limit}`);
    }
   
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
  
    const res = await axiosInstance.get(url);
    return res.data;
}

export const getBlogApi = async (id: string) => {
  const res = await axiosInstance.get(`${process.env.NEXT_PUBLIC_API}${Endpoints.BLOG.CREATE}/${id}`);
  return res.data;
};
